export class AdditionalData {
    id: any;
    name: any;
    email: any;
    dob: any;
    mobile: any;
    sex: any;
    address: any;
    distId: any;
    pin: any;
    designationId: any;
    departmentId: any;
    categoryId: any;
    phid: any;
    publjrnlno: any;
    publbooksno: any;
    publprocedingno: any;
    attndseminerno: any;
    attndconfno: any;
    attndworkshopno: any;
    phdguideno: any;
    researchprojno: any;
    apiscore: any;
    applicationNo: any;
    subjectsplname: any;
    userid: any;
    postcategoryid: any;
    advid: any;

    draftdate:any;
    oldbankdeaftno:any;
    drwanbank:any;
    drwanamount:any;

    phdthesisname:any;
    phdthesissubmitdate:any;
    phduniversity:any;
    publpeerjrnlno:any;
    publjrnlugcno:any;
    attndnationalseminerno:any;
    attndinternationalseminerno:any;
    awardstate:any;
    awardinternational:any;
    disciplinary:any;
    disciplinarydtls:any;
    researchno:any;
    researcharea:any;
    researchplaces:any;
    mphilresearchguidence:any;
    phdilresearchguidence:any;
    noticeperiod:any;
    mailingaddress:any;
    mailingpin:any;
    mailingdistId:any;
    permanentaddress:any;
    permanentpin:any;
    permanentdistId:any;
    fathername:any;
    mothername:any;
    nationalityid:any;
    religionid:any;
    maritalstatus:any;
    password :any;
    totalexperience : any;
    presentlyemployed:any;
    photo:any;
    sign:any;
    dateofbirthcertificate:any;
    castecertificate:any;
    phcertificate:any;
    currentemployercertificate:any;

    academicData: {
        academicyr: any,
        edudetail: any;
        exampass: any;
        id: any;
        parent_id: any;
        marks: any;
        subjectstudied: any;
        otherinfo: any;
        division: any;
        certificate :any;
        certificatename : any;
    }[];
    experienceData: {
        id: any;
        parent_id: any;
        instituteName: any;
        yearcount: any;
        typeofemployee: any;
        payscale:any;
        remarks:any;
        designation:any;
        //fromdate: any;
        //todate: any;

        //monthcount: any;

        //institutetype:any;

        //presentemployer:any;
    }[];

}



// WEBPACK FOOTER //
// ./src/app/new-admin-panel/AdditionalData.ts